import { render, staticRenderFns } from "./ModeloParametrosLabel.vue?vue&type=template&id=107a9dd8&"
import script from "./ModeloParametrosLabel.vue?vue&type=script&lang=js&"
export * from "./ModeloParametrosLabel.vue?vue&type=script&lang=js&"
import style0 from "./ModeloParametrosLabel.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports